let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eQWl8")).then(() => parcelRequire('6PdLM'));